import React, { createContext, useState, useEffect, useContext } from 'react';
import api from '../services/api'; 
const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const accessToken = localStorage.getItem('accessToken');
    const fetchUser = async () => {
      try {
        const res = await api.get('/auth/me/');
        setUser(res.data);  // { username, full_name, role, email }
      } catch (err) {
        console.error('Ошибка при получении пользователя:', err);
        setUser(null);
      } finally {
        setIsLoading(false);
      }
    };
    if (accessToken) {
      fetchUser();
    } else {
      setIsLoading(false);
    }
  }, []);
  return (
    <UserContext.Provider value={{ user, setUser, isLoading }}>
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => useContext(UserContext);
